import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { Button, Container, Grid, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { ErrorIcon } from '../../../icons/ErrorIcon';
import Hello from './Hello.png';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      justifyContent: 'space-between',
    },
    /*
    The size of the image is explicitly stated here so that this content can properly be centered vertically
    before the image is loaded.
    */
    illustration: {
      width: '284px',
      height: '284px',
      [theme.breakpoints.down('md')]: {
        width: '200px',
        height: '200px',
      },
    },
  })
);

export function GetStarted() {
  const { t } = useTranslation();
  const { nextPane, state } = useAppStateContext();
  const classes = useStyles();

  return (
    <Container>
      <Grid container alignItems="center" className={classes.gridContainer}>
        <Grid item lg={5}>
          {state.appIsExpired ? (
            <>
              <Typography variant="h1" gutterBottom>
                <ErrorIcon />
                {t('Expired.Title')}
              </Typography>

              <Typography variant="body1" gutterBottom>
                {t('Expired.Desc')}
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h1" gutterBottom>
                {t('Start.Title')}
              </Typography>

              <Typography variant="body1" gutterBottom>
                {t('Start.Desc')}
              </Typography>
            </>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={nextPane}
            style={{ marginBottom: '1em', color: 'white' }}
            disabled={state.appIsExpired}
          >
            {t('Start.Button.GetStarted')}
          </Button>
        </Grid>

        <Grid item lg={5}>
          <img src={Hello} alt="Hello" className={classes.illustration} />
          <Typography variant="body1" color="textSecondary" gutterBottom>
            <strong>{t('Start.NotSure')}</strong>
            {t('Start.NotSureDescription')}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}
